import { ITochiAnimation } from "@snackpass/snackpass-types";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Route, Routes, useSearchParams } from "react-router-dom";
import api from "src/utils/api";
import {
  setActiveAnim,
  setAnimClips,
  setAnims,
} from "src/utils/redux/tochiAnimation";
import { setAssets } from "src/utils/redux/tochiAsset";
import { setChicken } from "src/utils/redux/tochiChicken";
import { AnimationClip } from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import ChickenScreen from "./screens/ChickenScreen";
import PreviewScreen from "./screens/PreviewScreen";
import styled from "styled-components";

const App = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const token = searchParams.get("token");
  const id = searchParams.get("id");
  const version = searchParams.get("version");

  const loadAnim = (anim: ITochiAnimation) =>
    new Promise((res, rej) =>
      new GLTFLoader().load(anim.anim.asset, (gltf) => {
        if (gltf.animations.length) {
          gltf.animations[0].name = anim.name;
          return res(gltf.animations[0]);
        }
        return rej();
      })
    );

  const handleFetch = async () => {
    try {
      setError("");
      if (!token || !id || !version) return;
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      const [
        { data: animData },
        { data: assetData },
        { data: chickenData },
        { data: userData },
      ] = await Promise.all([
        api.tochi.getAnims(version, config),
        api.tochi.getAssets(version, config),
        api.tochi.getChickenById(id, version, config),
        api.tochi.getUser(config),
      ]);
      const { chicken } = chickenData;
      dispatch(setChicken(chicken));
      const lastChirp =
        chicken.parents[0]._id === userData.user._id
          ? chicken.parents[0].lastChirp
          : chicken.parents[1].lastChirp;
      if (lastChirp?.animation?.name) {
        dispatch(setActiveAnim(lastChirp.animation.name));
      }
      dispatch(setAssets(assetData));
      const anims = (animData.anims || []) as ITochiAnimation[];
      dispatch(setAnims(animData.anims || []));
      dispatch(
        setAnimClips(
          (await Promise.all(
            anims.map((anim) => loadAnim(anim))
          )) as AnimationClip[]
        )
      );
    } catch (e) {
      console.log(e);
      setError("Cannot load chicken");
    } finally {
      if ((window as any).ReactNativeWebView)
        (window as any).ReactNativeWebView.postMessage(
          JSON.stringify({ type: "TOCHI_LOADING", data: false })
        );
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!token || !id || !version) return;
    handleFetch();
  }, []);

  if (isLoading) return null;
  if (!token) return <Container>No token</Container>;
  if (!id) return <Container>No chicken</Container>;
  if (!version) return <Container>No version</Container>;
  if (error.length) return <Container>{error}</Container>;

  return (
    <Routes>
      <Route path="/" element={<ChickenScreen version={version} />} />
      <Route path="/preview" element={<PreviewScreen version={version} />} />
    </Routes>
  );
};

export default App;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  text-align: center;
  height: 100vh;
`;
